import { IRecord, IRecordType } from 'annotation-tools/utils';

// immutable object generator
export const ILabelSummary = IRecord<LabelSummaryType>({
  id: 0,
  name: '',
  color: '',
  count: 0
});

// immutable type
export type ILabelSummaryType = IRecordType<LabelSummaryType>;

export type LabelSummaryType = {
  id: number;
  name: string;
  color: string;
  count: number;
};
